var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal", class: _vm.bemFacet }, [
    _c("div", { staticClass: "modal--close-wrap" }, [
      _c("div", { staticClass: "modal--close" }, [
        _c(
          "button",
          {
            staticClass: "modal--close-button btn btn__bubble btn__large",
            class: _vm.buttonClasses,
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.closeOverlay($event)
              }
            }
          },
          [
            !_vm.isSmallDevice ? _c("cmp-ink-ripple") : _vm._e(),
            _vm._v(" "),
            _c("cmp-icon", {
              staticClass: "btn--bubble-icon",
              attrs: { symbol: "close", size: "small" }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    !!_vm.$slots.header
      ? _c("header", { staticClass: "modal--header" }, [_vm._t("header")], 2)
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.default
      ? _c("main", { staticClass: "modal--body" }, [_vm._t("default")], 2)
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.footer
      ? _c("footer", { staticClass: "modal--footer" }, [_vm._t("footer")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-065377a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-065377a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/ui/modal/index.vue
// module id = 439
// module chunks = 5